import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4519e2fe&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=4519e2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519e2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4519e2fe')) {
      api.createRecord('4519e2fe', component.options)
    } else {
      api.reload('4519e2fe', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4519e2fe&scoped=true&", function () {
      api.rerender('4519e2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22oaMpNuyLMP3/JS/comp/SearchFilterTokens.vue"
export default component.exports